import React, { FC, useState } from 'react'

import Modal from 'uiKit/Modal'
import { requestSupervisionAccess } from 'tabs/home/api/usageLimits'

import * as S from './UsageMeter.style'

interface Props {
  open: boolean
  onClose: () => void
  botId: string | number
}

/**
 * Confirmation for asking to add Supervision to an organisation whose package
 * does not currently include it. Adding a feature is a manual decision on the
 * CareBrain side, so this only sends the request.
 */
export const RequestSupervisionAccessModal: FC<Props> = ({ open, onClose, botId }) => {
  const [sending, setSending] = useState(false)

  const handleSend = (): void => {
    setSending(true)
    // Stays open on failure (the error alert has already shown) so the request can be retried.
    requestSupervisionAccess(botId).then(sent => {
      if (sent) onClose()
      else setSending(false)
    })
  }

  return (
    <Modal open={open} onClose={onClose} tabIndex="-1">
      <S.ModalBody>
        <S.ModalTitle>Request supervision for this organisation?</S.ModalTitle>
        <S.ModalText>
          Supervision isn&rsquo;t part of this organisation&rsquo;s current package. We&rsquo;ll send this
          request to your admin, who&rsquo;ll confirm the change and add it for you.
        </S.ModalText>

        <S.ModalActions>
          <S.GhostButton onClick={onClose}>Cancel</S.GhostButton>
          <S.PrimaryButton disabled={sending} onClick={handleSend}>
            {sending ? 'Sending…' : 'Send request'}
          </S.PrimaryButton>
        </S.ModalActions>
      </S.ModalBody>
    </Modal>
  )
}

export default RequestSupervisionAccessModal
